import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { EQueryKeys } from 'constants/enums';
import useAxios from 'hooks/useAxios';
import { getPublisherIdByPortalId } from 'utils/portalUtils';

import {
  EApiRoutes,
  fetchConfig,
  getApiRouteOrMock
} from './api.utils';
import { useUserDetails } from './useUserDetails';

export interface BlockedPlayersParams {
  limit: number;
  offset: number;
  playerId?: string;
  banReason?: string;
  isBlocked?: boolean;
  startDate?: string;
  endDate?: string;
}

export default function useBlockedPlayers(params: BlockedPlayersParams) {
  const axios = useAxios();
  const { publisherId, portalId } = useParams();
  const { userDetails } = useUserDetails();

  const effectivePublisherId = publisherId || (portalId ? getPublisherIdByPortalId(portalId, userDetails) : undefined);
  const publisherHeader = effectivePublisherId ? { 'x-publishers': effectivePublisherId } : undefined;

  const { limit, offset, playerId, banReason, isBlocked, startDate, endDate } = params;

  const getBlockedPlayers = useQuery({
    ...fetchConfig.list,
    queryKey: [
      EQueryKeys.BLOCKED_PLAYERS,
      effectivePublisherId,
      limit,
      offset,
      playerId ?? null,
      banReason ?? null,
      isBlocked ?? null,
      startDate ?? null,
      endDate ?? null
    ],
    queryFn: async () => {
      const queryParams = Object.fromEntries(
        Object.entries({ limit, offset, playerId, banReason, isBlocked, startDate, endDate })
          .filter(([, value]) => value !== undefined)
      );

      return await axios.get(
        getApiRouteOrMock(EApiRoutes.BLOCKED_PLAYERS),
        queryParams,
        publisherHeader
      );
    },
    enabled: !!effectivePublisherId
  });

  return {
    getBlockedPlayers
  };
}
